import React, { useEffect } from 'react'

import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetCourse } from '../../../store/course-store/course-actions';
import { getTokenInfo } from '../../../utils/Guard';

let callOnce = true;

const ZoomMeeting = () => {
  
  const param = useParams();
  const dispatch = useDispatch();
  const userInfo = getTokenInfo();
  const course = useSelector((state) => state.course.course);

    useEffect(() => {
      if (
        course === undefined ||
        course === null ||
        course.id === null ||
        course.id === undefined ||
        course.id === 0
      ) {
        if (
          userInfo !== undefined &&
          userInfo !== null &&
          userInfo.UserId !== null &&
          userInfo.UserId !== undefined &&
          param.courseid !== undefined &&
          callOnce
        ) {
          callOnce = false;
          dispatch(
            GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
          );
        } else {
          if (callOnce) {
            callOnce = false;
            dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
          }
        }
      }
    }, [course, dispatch, param.courseid, userInfo]);  useEffect(() => {
        if (
          course === undefined ||
          course === null ||
          course.id === null ||
          course.id === undefined ||
          course.id === 0
        ) {
          if (
            userInfo !== undefined &&
            userInfo !== null &&
            userInfo.UserId !== null &&
            userInfo.UserId !== undefined &&
            param.courseid !== undefined &&
            callOnce
          ) {
            callOnce = false;
            dispatch(
              GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
            );
          } else {
            if (callOnce) {
              callOnce = false;
              dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
            }
          }
        }
      }, [course, dispatch, param.courseid, userInfo]);


  return (
    <div>
      <iframe src={course.zoomUrl} allow="camera; microphone; display-capture" style={{width:"100%",height:"100vw"}}></iframe>
    </div>
  );

}


export default ZoomMeeting;